const de = require('../shared-resources/translations/de')

const defaultState = {
  translation: de.translation,
  currentLang: de.langKey,
  theme: null,
  account: null,
  token: null,
  cart: [],
  cartSleeveProducts: [],
  loginModalContext: { show: false, route: '' },
  projectListManager: {},
}

export default defaultState
